export const environment = {
  production: true, // Indica que este es un entorno de producción
  HOST: 'https://ab-api-cdni.sefintlax.gob.mx/certificadoDeNoInfraccion/solicitud-cdni', //URL de desrollo bakend real
  // HOST: 'http://10.20.0.11:8080/solicitud-cdni',
 // HOST_EDICION: 'https://api-cdni.sefintlax.gob.mx/certificadoDeNoInfraccion/cdni', //URL de desrollo bakend real
  HOST_DOCUMENT: 'https://ab-api-cdni.sefintlax.gob.mx/certificadoDeNoInfraccion', // URL del API doomy
  HOST_CAT: 'https://api-padron-vehicular.sefintlax.gob.mx/apiSicovet/catalogos/',
  catalogosEndpoint: 'https://a-catalogos-publicos.sefintlax.gob.mx/CatalogosPublicos/catalogosINEGI',
  HOST_EDICION: 'https://ab-api-cdni.sefintlax.gob.mx/certificadoDeNoInfraccion/cdni', //URL de desr

};

